import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RadioButtonUncheckedIcon(props: IconProps) {
    return <Icon {...props} iconKey={"radio_button_unchecked"}/>
}
